import { themeColors } from "../../themeColors";
/**
 * @file   src\mobile\pages\SettingsCheckEmail.js
 * @brief  This file is responsible check email page
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { pageURLs } from "@/constants";
import CountdownTimer from "../components/common/CountdownTimer";
import { toast } from "react-toastify";
import { resendEmail } from "../../services/v2/signupService";
import TopHeader from "../components/common/TopHeader";
import BackLinkButton from "../components/BackLinkButton";
import { resetPassword } from "../../services/loginService";
import { usePremium } from "@/hooks";

const SettingsCheckEmail = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const newEmailId = location.state && location.state["newEmailId"];

  const { shouldToggleColor } = usePremium();

  /**
   * To handle resend email
   */
  const resentEmail = () => {
    const userInfo = {
      Email: newEmailId,
      Process: "email_change",
    };
    resendEmail(userInfo).then((response) => {
      if (response) {
        if (_.get(response, "errorCode", false) === 0) {
          toast.success("Successfully resend the Email.");
        } else {
          toast.error(response.message);
        }
      }
    });
  };

  const openDefaultEmailApp = () => {
    window.location.href = `mailto:${newEmailId}`;
  };

  return (
    <>
      <div className="gitcha-main-wrapper pb-0">
        <div className="content-wrapper h-100">
          <TopHeader
            variant={"threeComp"}
            outerClassname="bg-white"
            topClassName="w-100 flex-column top-three-comp-headerborder"
            bottomClassName="w-100"
          >
            <BackLinkButton
              shouldToggleColor={shouldToggleColor}
              to={pageURLs.mobileAccountSettings}
            />
            <div className={shouldToggleColor ? "heading-premium" : "heading"}>
              Edit Email
            </div>
            <div className="p-0 toplinks-mobile">
              <div className="topbar-links notif-delete-btn d-none"></div>
            </div>
          </TopHeader>
          <div className="inner-layout-content-new h-100 ">
            <div className=" h-100  bg-grey-variant">
              <div className="checkEmailWrap">
                <div className="pb-3">
                  <span className="postboxicon"></span>
                  <h2>Check your email</h2>

                  <p className="mb-1">We’ve sent a login link to </p>
                  <a href={void 0}>{newEmailId}</a>
                </div>
                <button
                  type="button"
                  className="btn btn-primary w-100 mb-4"
                  onClick={() => openDefaultEmailApp()}
                >
                  Open email app
                </button>
                <div className="time">
                  <CountdownTimer resentEmail={resentEmail}></CountdownTimer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsCheckEmail;
